import { Link } from "react-router-dom";
import { Phone, Gavel, Globe } from "lucide-react";
import Reveal from "../components/Reveal";
import { useLang } from "../i18n/i18n";

const PLATFORMS = [
  { label: "about.plat1", url: "https://www.encansdesparois.com", tag: "www.encansdesparois.com" },
  { label: "about.plat2", url: "https://www.encansdesparois.com", tag: "www.encansdesparois.com" },
  { label: "about.plat3", url: "https://www.liveauctioneers.com", tag: "liveauctioneers.com" },
];

export default function About() {
  const { t } = useLang();

  return (
    <main className="pt-[72px]">
      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20" data-testid="about-header">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-gold">{t("about.eyebrow")}</p>
          <h1 className="mt-4 font-display text-5xl sm:text-7xl font-light text-cream leading-tight">
            Encans <em className="gold-text italic font-medium">Desparois</em>
          </h1>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-16 grid gap-12 lg:grid-cols-2" data-testid="about-story">
        <Reveal>
          <h2 className="font-display text-2xl text-goldlight">{t("about.storyT")}</h2>
          <p className="mt-4 text-base leading-relaxed text-cream/70">{t("about.storyD")}</p>
          <h2 className="mt-12 font-display text-2xl text-goldlight">{t("about.missionT")}</h2>
          <p className="mt-4 text-base leading-relaxed text-cream/70">{t("about.missionD")}</p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="rounded-3xl border border-gold/20 bg-panel/70 p-8 sm:p-10">
            <Gavel size={26} className="text-gold" strokeWidth={1.5} />
            <p className="mt-6 font-display text-xl sm:text-2xl leading-relaxed text-cream/90">{t("about.quote")}</p>
            <p className="mt-6 text-xs uppercase tracking-[0.3em] text-mutedc">{t("about.quoteRole")}</p>
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-24" data-testid="about-platforms">
        <Reveal>
          <div className="flex items-center gap-4">
            <Globe size={20} className="text-gold" />
            <h2 className="font-display text-2xl sm:text-3xl text-cream">{t("about.platT")}</h2>
          </div>
        </Reveal>
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {PLATFORMS.map((p, i) => (
            <Reveal key={i} delay={0.06 * i} className="h-full">
              <a
                href={p.url}
                target="_blank"
                rel="noreferrer"
                data-testid={`about-platform-link-${i}`}
                className="block h-full rounded-2xl border border-gold/15 bg-panel/70 p-7 transition-all hover:border-gold/45 hover:-translate-y-1 duration-300"
              >
                <p className="font-display text-lg text-cream">{t(p.label)}</p>
                <p className="mt-2 text-sm text-goldlight/80">{p.tag}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-24" data-testid="about-contact-cta">
        <Reveal>
          <div className="rounded-3xl border border-gold/20 bg-gradient-to-r from-panel2 to-panel p-8 sm:p-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <p className="font-display text-2xl sm:text-3xl text-cream">{t("about.ctaT")}</p>
              <p className="mt-2 text-cream/60">{t("about.ctaD")}</p>
            </div>
            <a
              href="tel:514-378-8833"
              data-testid="about-phone-link"
              className="inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 text-base font-semibold text-ink tabular hover:bg-goldlight transition-all"
            >
              <Phone size={18} /> 514-378-8833
            </a>
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-3xl px-5 sm:px-8 pb-24" data-testid="about-privacy">
        <Reveal>
          <h2 className="font-display text-xl text-cream/90">{t("about.privacyT")}</h2>
          <p className="mt-4 text-sm leading-relaxed text-mutedc">{t("about.privacyD")}</p>
          <Link
            to="/confidentialite"
            data-testid="about-privacy-full-link"
            className="mt-5 inline-flex items-center gap-2 text-sm text-goldlight underline decoration-gold/40 underline-offset-4 hover:decoration-goldlight transition-all"
          >
            {t("pp.h1")}
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
